import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarNew from '../NewAdminPanel/Common/AdminSideBar';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { Box, Button, Hidden } from "@mui/material";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import blockedData from "../../config/blockedSchemes.json";
import { none } from 'ol/centerconstraint';


// Export constant loaded from JSON
export const BLOCKED_SCHEMES = blockedData.BLOCKED_SCHEMES;

const UserList = () => {

  const userType = sessionStorage.getItem("userTypeCodeModel");
  const stateFromSession = sessionStorage.getItem("stateNameModel");
  


  const schemeGlobal = String(sessionStorage.getItem("schemeCodeModel") || "");
  const isSchemeBlocked = BLOCKED_SCHEMES.includes(schemeGlobal);
  //console.log('isSchemeBlocked: ', isSchemeBlocked);
  sessionStorage.setItem("isSchemeBlocked", isSchemeBlocked);
  const navigate = useNavigate();
  const [usersData, setUsersData] = useState([]);
  const [deleteCode, setDeleteCode] = useState({});
  const [isFetching, setIsFetching] = useState(true);
  const [selectedState, setSelectedState] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [showTable, setShowTable] = useState(userType !== "1");
  const [isStateDisabled, setIsStateDisabled] = useState(false);
  const [stateOptions, setOptionState] = useState([]);
  const [optionDistrict, setOptionDistrict] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (userType === "2" && stateFromSession) {
      setSelectedState(stateFromSession);
      setIsStateDisabled(true);

      // load districts
      handleState(stateFromSession);
    }
  }, [userType, stateFromSession]);
  useEffect(() => {

    getStates();

    if (userType !== "1") {
      fetchData(); // non-central users
    }
  }, []);

  useEffect(() => {
    if (userType === "2") {
        const stateCode = sessionStorage.getItem("stateNameModel");

        if (stateCode && stateCode !== "null") {
            setSelectedState(String(stateCode)); // IMPORTANT
            handleState(String(stateCode));      // load districts
        }
    }
}, [userType]);

useEffect(() => {
    const userType = sessionStorage.getItem("userTypeCodeModel");
    const stateCode = sessionStorage.getItem("stateNameModel");

    if (userType === "2" && stateCode) {
        setSelectedState(stateCode);
        handleState(stateCode);
    }
}, []);

 const fetchDataStateAdmin = async (stateCode, districtCode) => {

    let result;
    if (sessionStorage.getItem("schemeCodeModel") !== "13" && sessionStorage.getItem("schemeCodeModel") !== "12") {
      const schemeCode = sessionStorage.getItem("schemeCodeModel");
      const apiBaseUrl = process.env.NODE_ENV === 'development'
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE;

      const getValue = (key, fallback = 0) => {
        const value = sessionStorage.getItem(key);
        return !value || value === "null" ? fallback : value;
      };

      const payload = {

        StateCode: stateFromSession || 0,
        districtCode: districtCode|| 0,
        subDistrictCode: 0,
        blockCode: 0,
        villageCode: "0",
        UserTypeCode:  0,
        schemeCode: schemeCode === "null" || !schemeCode ? 0 : schemeCode,

      };

      console.log('payload111:', payload)
      let result;
      if (schemeCode !== "5") {
        console.log('inside if');
        result = await axios.post(`${apiBaseUrl}/api/Management/CommUsers/getFilterUsersExt`, payload);
      } else {
        console.log('inside else');
        result = await axios.post(`${apiBaseUrl}/api/NMEOSUsers/getFilterNMEOSUsersExt`, payload);
      }


      console.log('result.data.dataContent:', result.data.dataContent);
      // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);
      setUsersData(result.data.dataContent);
      setIsFetching(false);
    }
    else {
      //console.log("test scheme data ", sessionStorage.getItem("schemeCodeModel"));
      result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/gt/users/getUsersExtInternalUsers`, {

        "userCode": sessionStorage.getItem("userCodeModel"),
        "schemeCode": sessionStorage.getItem("schemeCodeModel") === "null" ? 0 : sessionStorage.getItem("schemeCodeModel"),

        //    "orgTypeCode": "1"

      }



      );
      // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);
      setUsersData(result.data.dataContent);
      setIsFetching(false);
    }
  };
  const fetchDataCentral = async (stateCode, roleCode) => {

    let result;
    if (sessionStorage.getItem("schemeCodeModel") !== "13" && sessionStorage.getItem("schemeCodeModel") !== "12") {
      const schemeCode = sessionStorage.getItem("schemeCodeModel");
      const apiBaseUrl = process.env.NODE_ENV === 'development'
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE;

      const getValue = (key, fallback = 0) => {
        const value = sessionStorage.getItem(key);
        return !value || value === "null" ? fallback : value;
      };

      const payload = {

        StateCode: stateCode || 0,
        districtCode: 0,
        subDistrictCode: 0,
        blockCode: 0,
        villageCode: "0",
        UserTypeCode: roleCode || 0,
        schemeCode: schemeCode === "null" || !schemeCode ? 0 : schemeCode,

      };

      console.log('payload111:', payload)
      let result;
      if (schemeCode !== "5") {
        console.log('inside if');
        result = await axios.post(`${apiBaseUrl}/api/Management/CommUsers/getFilterUsersExt`, payload);
      } else {
        console.log('inside else');
        result = await axios.post(`${apiBaseUrl}/api/NMEOSUsers/getFilterNMEOSUsersExt`, payload);
      }


      console.log('result.data.dataContent:', result.data.dataContent);
      // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);
      setUsersData(result.data.dataContent);
      setIsFetching(false);
    }
    else {
      //console.log("test scheme data ", sessionStorage.getItem("schemeCodeModel"));
      result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/gt/users/getUsersExtInternalUsers`, {

        "userCode": sessionStorage.getItem("userCodeModel"),
        "schemeCode": sessionStorage.getItem("schemeCodeModel") === "null" ? 0 : sessionStorage.getItem("schemeCodeModel"),

        //    "orgTypeCode": "1"

      }



      );
      // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);
      setUsersData(result.data.dataContent);
      setIsFetching(false);
    }
  };
  const fetchData = async () => {
    let result;//sessionStorage.getItem("schemeCodeModel") !== "12" || 
    if (sessionStorage.getItem("schemeCodeModel") !== "13" && sessionStorage.getItem("schemeCodeModel") !== "12") {
      const schemeCode = sessionStorage.getItem("schemeCodeModel");
      const apiBaseUrl = process.env.NODE_ENV === 'development'
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE;

      const getValue = (key, fallback = 0) => {
        const value = sessionStorage.getItem(key);
        return !value || value === "null" ? fallback : value;
      };





      //alert(userType);

      const payload = {
        ...(userType !== "1" && {
          stateCode: getValue("stateNameModel"),
        }),
        //districtCode: getValue("districtNameModel"),districtCodeModel
        districtCode: getValue("districtCodeModel"),
        subDistrictCode: getValue("subDistrictCodeModel"),
        blockCode: 0,
        villageCode: getValue("villageModel", ""),
        schemeCode: schemeCode === "null" || !schemeCode ? 0 : schemeCode,
        ...(schemeCode === "8" && {
          userTypeCode: userType,
        }),
      };

      console.log('payload111:', payload)
      let result;
      if (schemeCode !== "5") {
        console.log('inside if');
        result = await axios.post(`${apiBaseUrl}/api/Management/CommUsers/getFilterUsersExt`, payload);
      } else {
        console.log('inside else');
        result = await axios.post(`${apiBaseUrl}/api/NMEOSUsers/getFilterNMEOSUsersExt`, payload);
      }


      console.log('result.data.dataContent:', result.data.dataContent);
      // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);
      setUsersData(result.data.dataContent);
      setIsFetching(false);
    }
    else {
      //console.log("test scheme data ", sessionStorage.getItem("schemeCodeModel"));
      result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/gt/users/getUsersExtInternalUsers`, {

        "userCode": sessionStorage.getItem("userCodeModel"),
        "schemeCode": sessionStorage.getItem("schemeCodeModel") === "null" ? 0 : sessionStorage.getItem("schemeCodeModel"),

        //    "orgTypeCode": "1"

      }



      );
      // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);
      setUsersData(result.data.dataContent);
      setIsFetching(false);
    }
  };

  const handleApplyFilter = () => {
    if (!selectedState || !selectedRole) {
      setErrorMessage("Please select State and Role");
      return;
    }
    setErrorMessage(""); // Clear error message if validation passes
    setShowTable(true);
    fetchDataCentral(selectedState, selectedRole);
  };


  function removed() {
    var mpopup = document.getElementById('mpopupBox');
    mpopup.style.display = "none";

  }

  function viewData(userData) {
    // Derive gender safely to avoid runtime errors and stale UI
    let gender = "-";
    try {
      const g = (userData && userData.gender ? String(userData.gender) : "").trim().charAt(0).toUpperCase();
      gender = g === "M" ? "Male" : g === "F" ? "Female" : g === "T" ? "Transgender" : "-";
    } catch (_) {
      gender = "-";
    }


    console.log("value!!$", userData)

    var x = document.createElement("a");
    x.id = "mpopupLink";
    var mpopup = document.getElementById('mpopupBox');
    // Put a lightweight spinner first to keep click responsive
    var modalContentEl = document.getElementById("modal-content");
    if (modalContentEl) {
      modalContentEl.innerHTML = '<div class="py-4 text-center"><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></div>';
    }
    mpopup.style.display = "block";
    let __modalHtml = ""; // staged HTML string to inject
    if (sessionStorage.getItem("schemeCodeModel") === "12" || sessionStorage.getItem("schemeCodeModel") === "13") {
      console.log("userData", userData);
      let datastatename = userData.states.map(item => `${item.stateName}`).join(',');
      const districtNamesArray = [];
      const subDistrictNamesArray = [];
      userData.states.forEach(state => {
        state.districts.forEach(district => {
          districtNamesArray.push(district.districtName);
          district.subDistricts.forEach(subDistrict => {
            subDistrictNamesArray.push(subDistrict.subDistrictName);
          });
        });
      });
      let districtNamesArrays = districtNamesArray.join(', ');
      let subdistrictNamesArrays = subDistrictNamesArray.join(', ');
      // alert(districtNamesArrays);
      //alert(subdistrictNamesArrays);

      __modalHtml = `<h5 class="formgrouping">User Details</h5> <div class="row"> <div class="col-md-4"> <h6>User Name</h6> <p> ${userData.userName} </p> </div> <div class="col-md-4"> <h6>Email Id</h6> <p> ${userData.emailId} </p> </div> <div class="col-md-4"> <h6>Mobile No.</h6> <p> ${userData.mobile} </p> </div>  <div class="col-md-4"> <h6>Gender</h6> <p> ${gender} </p> </div> </div> <h5 class="formgrouping">User Credential-test</h5> <div class="row"> <div class="col-md-3"> <h6>User Id</h6> <p> ${userData.userId}</p> </div> <div class="col-md-3"> <h6>Password</h6> <p>${userData.password}</p> </div> <div class="col-md-3"> <h6>Is Visible</h6> <p>${userData.isVisible}</p> </div>  <div class="col-md-3"> <h6>Is Active</h6> <p>${userData.isActive}</p> </div></div> <h5 class="formgrouping">Official Details</h5> <div class="row"> <div class="col-md-4"> <h6>Designation Name</h6> <p>${userData.desigName}</p> </div> <div class="col-md-4"> <h6>Scheme Name</h6> <p>${userData.schemeName}</p> </div>  <div class="col-md-4"> <h6>States</h6> <p> ${datastatename}</p>  </div>  ${' <div class="col-md-4"> <h6>Districts</h6> <p>' + districtNamesArrays + '</p>  </div>'}  ${'<div class="col-md-4"> <h6>SubDistricts</h6> <p>' + subdistrictNamesArrays + '</p> </div>'} ${userData.villageName ? '<div class="col-md-12"> <h6>Village Name</h6> <p>' + userData.villageName + ' </p> </div>' : ""}     </div>`;
    } else if (sessionStorage.getItem("schemeCodeModel") === "15") {
      __modalHtml = `
    <h5 class="formgrouping">User Details</h5>
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>User Name</th>
          <th>User Role</th>
          <th>Email Id</th>
          <th>Mobile No.</th>
          <th>Gender</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>${userData.userName}</td>
          <td>${userData.userRoleName}</td>
          <td>${userData.emailId}</td>
          <td>${userData.mobile}</td>
          <td>${gender}</td>
        </tr>
      </tbody>
    </table>

    <h5 class="formgrouping">User Credential</h5>
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>User Id</th>
          <th>Password</th>
          <th>Is Visible</th>
          <th>Is Active</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>${userData.userId}</td>
          <td>
            <span id="password-text" style="letter-spacing: 2px;">••••••••</span>
            <span id="real-password" style="display: none;">${userData.password}</span>
            <button id="toggle-password" style="border: none; background: none; cursor: pointer;">👁️</button>
          </td>
          <td>${userData.isVisible}</td>
          <td>${userData.isActive}</td>
        </tr>
      </tbody>
    </table>

    <h5 class="formgrouping">Official Details</h5>
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>Designation Name</th>
          <th>Scheme Name</th>
          <th>State Name</th>
          ${userData.districtName ? `<th>District Name</th>` : ""}
          ${userData.subDistrictName ? `<th>SubDistrict Name</th>` : ""}
          ${userData.villageName ? `<th>Village Name</th>` : ""}
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>${userData.desigName}</td>
          <td>${userData.schemeName}</td>
          <td>${userData.stateName}</td>
          ${userData.districtName ? `<td>${userData.districtName}</td>` : ""}
          ${userData.subDistrictName ? `<td>${userData.subDistrictName}</td>` : ""}
          ${userData.villageName ? `<td>${userData.villageName}</td>` : ""}
        </tr>
      </tbody>
    </table>
  `;
    }

    else {
      let districtDisplay;
      let subDistrictDisplay;
      let blockDisplaySubDisrict;
      let blockDisplay;
      const isSchemeBlockedCheck = sessionStorage.getItem("isSchemeBlocked") === "true";
      if (isSchemeBlockedCheck) {
        districtDisplay = userData.mulDistrictName && userData.mulDistrictName.trim() !== ''
          ? userData.mulDistrictName
          : userData.districtName || '-';


        // console.log('userData.mulSubDistrictName: ', userData.mulSubDistrictName);

        subDistrictDisplay = userData.mulSubDistrictName && userData.mulSubDistrictName.trim() !== ''
          ? userData.mulSubDistrictName
          : userData.subDistrictName || '';

        blockDisplaySubDisrict = userData.mulBlockName && userData.mulBlockName.trim() !== ''
          ? userData.mulBlockName
          : userData.mulBlockName || '';
        //console.log('blockDisplaySubDisrict: ', blockDisplaySubDisrict);

      } else {


        districtDisplay = userData.districtName || '';


        subDistrictDisplay = userData.subDistrictName || '';

        blockDisplaySubDisrict = userData.blockName || '';
        //console.log('blockDisplay: ', blockDisplay);
      }


      __modalHtml = `
              <h5 class="formgrouping">User Details</h5>
              <div class="row">
                <div class="col-md-4">
                  <h6>User Name</h6>
                  <p>${userData.userName}</p>
                </div>
                <div class="col-md-4">
                  <h6>Email Id</h6>
                  <p>${userData.emailId}</p>
                </div>
                <div class="col-md-4">
                  <h6>Mobile No.</h6>
                  <p>${userData.mobile}</p>
                </div>
                <div class="col-md-4">
                  <h6>Gender</h6>
                  <p>${gender}</p>
                </div>
              </div>

              <h5 class="formgrouping">User Credential</h5>
              <div class="row">
                <div class="col-md-3">
                  <h6>User Id</h6>
                  <p>${userData.userId}</p>
                </div>
                <div class="col-md-3">
                  <h6>Password</h6>
                  <p>
                    <span id="password-text" style="letter-spacing:2px;">••••••••</span>
                    <span id="real-password" style="display: none;">${userData.password}</span>
                    <button id="toggle-password" style="border: none; background: none; cursor: pointer;">👁️</button>
                  </p>
                </div>
                <div class="col-md-3">
                  <h6>Is Visible</h6>
                  <p>${userData.isVisible}</p>
                </div>
                <div class="col-md-3">
                  <h6>Is Active</h6>
                  <p>${userData.isActive}</p>
                </div>
              </div>

              <h5 class="formgrouping">Official Details</h5>
              <div class="row">
                <div class="col-md-4">
                  <h6>Designation Name</h6>
                  <p>${userData.desigName}</p>
                </div>
                <div class="col-md-4">
                  <h6>Scheme Name</h6>
                  <p>${userData.schemeName}</p>
                </div>
                <div class="col-md-4">
                  <h6>State Name</h6>
                  <p>${userData.stateName}</p>
                </div>
                <div class="col-md-4">
                  <h6>District Name</h6>
                  <p>${districtDisplay}</p>
                </div>
                ${subDistrictDisplay && subDistrictDisplay.trim() !== ''
          ? `<div class="col-md-4">
                     <h6>SubDistrict Name</h6>
                     <p>${subDistrictDisplay}</p>
                   </div>`
          : blockDisplaySubDisrict && blockDisplaySubDisrict.trim() !== ''
            ? `<div class="col-md-4">
                       <h6>Block Name</h6>
                       <p>${blockDisplaySubDisrict}</p>
                     </div>`
            : ""
        }               
             ${userData.villageName ? `<div class="col-md-12"><h6>Village Name</h6><p>${userData.villageName}</p></div>` : ""}
              </div>
            `;
    }
    // Defer DOM update to next frame, then attach toggle listener
    var schedule = (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function')
      ? window.requestAnimationFrame.bind(window)
      : function (cb) { setTimeout(cb, 0); };

    schedule(function () {
      if (modalContentEl) {
        modalContentEl.innerHTML = __modalHtml;
      }
      var toggleBtn = document.getElementById("toggle-password");
      if (toggleBtn) {
        toggleBtn.addEventListener("click", function () {
          const dots = document.getElementById("password-text");
          const realPass = document.getElementById("real-password");
          if (!dots || !realPass) return;
          if (dots.style.display === "none") {
            dots.style.display = "inline";
            realPass.style.display = "none";
          } else {
            dots.style.display = "none";
            realPass.style.display = "inline";
          }
        });
      }
    });

  }




  function deleteData(value) {
    //console.log('inside delete function');
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    // console.log('deleteCode payload: ', deleteCode);

    var raw = JSON.stringify(deleteCode);
    var requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    if (sessionStorage.getItem("schemeCodeModel") === "12" || sessionStorage.getItem("schemeCodeModel") === "13") {


      fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/Users`, requestOptions)
        .then(response => response.text())
        .then(result => {
          if (JSON.parse(result).success == true) {
            fetchData();

          }
        })
        .catch(error => console.log('error', error));
    } else if (sessionStorage.getItem("schemeCodeModel") === "5") {
      fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/NMEOSUsers`, requestOptions)
        .then(response => response.text())
        .then(result => {
          if (JSON.parse(result).success == true) {
            fetchData();

          }
        })
        .catch(error => console.log('error', error));
    }
    else {
      //console.log('api block');

      fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Management/CommUsers`, requestOptions)
        .then(response => response.text())
        .then(result => {
          if (JSON.parse(result).success == true) {
            fetchData();

          }
        })
        .catch(error => console.log('error', error));
    }
  }


  function handleEmail(originalRow) {

  }
  const getStates = () => {
    fetch(
      `${process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE
      }/api/states`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      }
    )
      .then(res => res.json())
      .then(result => {
        const states = (result.dataContent || []).map(item => ({
          value: item.stateCode,
          label: item.stateName
        }));

        setOptionState(states);

        const userType = sessionStorage.getItem("userTypeCodeModel");
        const stateCode = sessionStorage.getItem("stateNameModel");

        // Auto select for State / District admin
        if ((userType === "2" || userType === "3") && stateCode) {
          const match = states.find(
            s => String(s.value) === String(stateCode)
          );

          if (match) {
            setSelectedState(match);
            setIsStateDisabled(true);
          }
        }
      })
      .catch(err => console.error("State API error:", err));
  };
  const handleState = (stateCode) => {
    if (!stateCode) {
        setOptionDistrict([]);
        return;
    }

    fetch(
        `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/district`,
        {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ stateCode })
        }
    )
        .then(res => res.json())
        .then(result => {
            const districts = result?.dataContent || [];
            const formatted = districts.map(d => ({
                label: d.districtName,
                value: d.districtCode
            }));
            setOptionDistrict(formatted);
        })
        .catch(err => console.error("District API error", err));
};



  const handleExportToExcel = () => {
    const schemeCode = sessionStorage.getItem("schemeCodeModel");

    const filteredData = usersData.map(original => {
      // Handle gender formatting
      let genderValue = original.gender || '';
      let formattedGender = '';
      if (genderValue === 'u' || genderValue === 'U') {
        formattedGender = '-';
      } else if (genderValue === 'M' || genderValue === 'm') {
        formattedGender = 'Male';
      } else if (genderValue === 'F' || genderValue === 'f') {
        formattedGender = 'Female';
      } else if (genderValue === 'T' || genderValue === 't') {
        formattedGender = 'Transgender';
      } else {
        formattedGender = genderValue || '-';
      }

      // Handle District field (special case for scheme 8)
      let districtValue = '';
      if (schemeCode === "8") {
        districtValue =
          (original.mulDistrictName && original.mulDistrictName.trim() !== '')
            ? original.mulDistrictName
            : (original.districtName || '-');
      } else {
        districtValue = original.districtName || '';
      }

      return {
        "User Id": original.userId || '',
        "User Name": original.userName || '',
        "mobileNo": original.mobile || '',
        "State": original.stateName || '',
        "District": districtValue,
        "villageName": original.villageName || '',
        "Designation": original.desigName || '',
        "Surveyor Name": original.userName || '',
        "Email": original.emailId || '',
        "User Role": original.userRoleName || '',
        "Scheme": original.schemeName || '',
        "Gender": formattedGender
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(dataBlob, "UserList.xlsx");
  };

  function handleUserRole(originalRow) {

    let userRoleCode = originalRow.userTypeCode;

    if (userRoleCode === 1) {
      return "Central"

    } else if (userRoleCode === 2) {
      return "State"
    } else if (userRoleCode === 3) {
      return "District"
    } else if (userRoleCode === 4) {
      return "Sub-District"
    } else if (userRoleCode === 5) {
      return "Surveyor"
    } else if (userRoleCode === 6) {
      return "Sakhi"
    } else {
      return "Supervisor"
    }

  }

  const handleExportData = (table) => {
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const allowedFields =
      schemeCode === "2"
        ? ['schemeName', 'userRoleName', 'stateName', 'districtName', 'blockName', 'desigName', 'userName', 'mobile', 'emailId', 'gender']
        : schemeCode === "12" || schemeCode === "13"
          ? ['mobile', 'gender', 'desigName', 'userName', 'emailId', 'schemeName', 'companyName', 'stateName', 'districtName', 'userRoleName']
          : schemeCode === "8"
            ? ['stateName', 'districtName', 'subDistrictName', 'blockName', 'villageName', 'desigName', 'mobile', 'emailId', 'schemeName']
            : schemeCode === "5"
              ? ['userRoleName', 'stateName', 'districtName', 'desigName', 'userName', 'mobile', 'emailId', 'gender']
              : ['userName', 'stateName', 'districtName', 'subDistrictName', 'blockName', 'villageName', 'desigName', 'mobile', 'emailId', 'schemeName'];

    const filteredData = table.getPrePaginationRowModel().rows.map((row) => {
      const original = row.original;
      const formattedRow = {};

      allowedFields.forEach((field) => {
        if (field === 'gender') {
          // Handle gender mappings
          let genderValue = original[field] || '';
          if (genderValue === 'u' || genderValue === 'U') {
            formattedRow[field] = '-';
          } else if (genderValue === 'M' || genderValue === 'm') {
            formattedRow[field] = 'Male';
          } else if (genderValue === 'F' || genderValue === 'f') {
            formattedRow[field] = 'Female';
          } else if (genderValue === 'T' || genderValue === 't') {
            formattedRow[field] = 'Transgender';
          } else {
            formattedRow[field] = genderValue || '-';
          }
        } else if (field === 'districtName' && schemeCode === "8") {
          // Special handling for scheme 8: prefer multiDistrictName
          formattedRow[field] =
            (original.mulDistrictName && original.mulDistrictName.trim() !== '')
              ? original.mulDistrictName
              : (original.districtName || '-');
        } else {
          // Default field handling
          formattedRow[field] = original[field] || '';
        }
      });

      return formattedRow;
    });

    const csvOptions = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: false,
      headers: allowedFields,
    };

    const csvExporter = new ExportToCsv(csvOptions);
    csvExporter.generateCsv(filteredData);
  };





  const schemeCode = sessionStorage.getItem("schemeCodeModel");


  const columns = useMemo(
    () => [
      {
        header: 'S.No',
        Cell: cell => Number(cell.row.id) + 1,
        size: 80, // set width
        muiTableBodyCellProps: { sx: { px: 1, py: 0.5 } }, // reduce padding
      },
      {
        accessor: '',
        header: 'Actions',
        Cell: cell =>
          String(cell.row.original.userCode) === sessionStorage.getItem("userCodeModel") ? "" : (
            <>
              <i className="btn text-success" onClick={() => viewData(cell.row.original)}>
                <FontAwesomeIcon icon={faEye} />
              </i>

              {["12", "13"].includes(sessionStorage.getItem("schemeCodeModel")) ? null : (
                <i className="btn text-primary" onClick={() => navigate("/newadminpanel/usercreation", { state: { cropSurveyCode: cell.row.original } })}>
                  <FontAwesomeIcon icon={faPencil} />
                </i>
              )}

              {/* <i className="btn text-danger" data-bs-toggle="modal" data-bs-target="#staticBackdrop_user" onClick={() => setDeleteCode({ userCode: cell.row.original.userCode })}>
                <FontAwesomeIcon icon={faTrashAlt} />
              </i> */}
            </>
          ),
        size: 120,
        muiTableBodyCellProps: { sx: { px: 1, py: 0.5 } },
      },
      {
        accessorKey: 'userRoleName',
        header: 'Role',
        size: 120,
      },
      {
        accessorKey: 'mobile',
        header: 'mobile',
        size: 120,
      },
      ...(
        schemeCode !== "12"
          ? [{
            accessorKey: ["12", "13"].includes(schemeCode) ? 'mobile' : 'stateName',
            header: ["12", "13"].includes(schemeCode) ? 'Mobile' : 'State',
            size: 100,
          }]
          : []
      ),





      {
        accessorKey: (() => {
          const scheme = sessionStorage.getItem("schemeCodeModel");
          if (scheme === "12" || scheme === "13") return "gender";
          if (scheme === "8") return "mulDistrictName"; // fallback handled in Cell
          return "districtName";
        })(),

        header: (() => {
          const scheme = sessionStorage.getItem("schemeCodeModel");
          if (scheme === "12" || scheme === "13") return "Gender";
          return "District";
        })(),

        size: 140,

        Cell: ({ row }) => {
          const scheme = sessionStorage.getItem("schemeCodeModel");

          if (scheme === "12" || scheme === "13") {
            return row.original.gender || "-";
          }

          if (scheme === "8") {
            const multiDistrictName = row.original.mulDistrictName;
            const districtName = row.original.districtName;

            if (multiDistrictName && multiDistrictName.trim() !== "") {
              return multiDistrictName;
            } else if (districtName && districtName.trim() !== "") {
              return districtName;
            } else {
              return "-";
            }
          }

          // Default case
          const districtName = row.original.districtName;
          const multiDistrict = row.original.mulDistrictName;

          if (multiDistrict && multiDistrict.trim() !== "") {
            return multiDistrict; // already comma-separated string
          } else if (districtName && districtName.trim() !== "") {
            return districtName;
          } else {
            return "-";
          }

        }
      },
      {
        accessorKey: 'userName',
        header: 'User Name',
        size: 150,
      },
      {
        accessorKey: 'emailId',
        header: 'Email',
        Cell: ({ cell }) => (
          <span style={{ textTransform: 'none' }}>{cell.getValue()}</span>
        ),
        size: 180,
      },


    ],
    []
  );


  return (
    <>
      <AdminHeaderNew />
      <AdminSideBarNew />

      <main id="main" className="main">
        <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
          <nav>
            <h1>Users List</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">User Management</li>
              <li className="breadcrumb-item active">Users</li>
            </ol>
          </nav>
          {sessionStorage.getItem(
            "schemeCodeModel"
          ) === "12" && sessionStorage.getItem(
            "userTypeCodeModel"
          ) === "1" || sessionStorage.getItem(
            "schemeCodeModel"
          ) === "13" && sessionStorage.getItem(
            "userTypeCodeModel"
          ) === "1" ? (
            <button type="button" className="btn btn-success"  onClick={() => navigate("/newadminpanel/centrallogin")}>New users will now be created through KM2 Login.</button>
          ) : sessionStorage.getItem(
            "schemeCodeModel"
          ) === "12" && sessionStorage.getItem(
            "userTypeCodeModel"
          ) != "1" || sessionStorage.getItem(
            "schemeCodeModel"
          ) === "13" && sessionStorage.getItem(
            "userTypeCodeModel"
          ) != "1" ? 
          (
             <button
  type="button"
  className="btn btn-success"
  style={{ display: "" }}
   disabled
  onClick={() => navigate("/newadminpanel/companylogin")}
>
  New users will now be created through KM2 Login.
</button>
          ) 
          : (
            <button
  type="button"
  className="btn btn-success"
  style={{ display: "" }}
  disabled
  onClick={() => navigate("/newadminpanel/companylogin")}
>
  New users will now be created through KM2 Login.
  
</button>
          )
          }



        </div>
        <section className="section">
          {userType === "1" && (
            <div className="card p-3 mb-3">
              <div className="row g-3">

                {/* STATE */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold">State</label>
                  <select
                    className="form-select"
                    value={selectedState}
                    onChange={(e) => {
                      setSelectedState(e.target.value);
                      setErrorMessage(""); // Clear error when user changes selection
                    }}
                  >
                    <option value="">Select State</option>
                    {stateOptions.map(state => (
                      <option key={state.value} value={state.value}>
                        {state.label}
                      </option>
                    ))}
                  </select>
                </div>

                {/* ROLE */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold">Role</label>
                  <select
                    className="form-select"
                    value={selectedRole}
                    onChange={(e) => {
                      setSelectedRole(e.target.value);
                      setErrorMessage(""); // Clear error when user changes selection
                    }}
                  > 
                    <option value="">Select Role</option>
                    <option value="2">State</option>
                    <option value="3">District</option>
                    <option value="4">Sub-District</option>
                    <option value="5">Surveyor</option>
                    {sessionStorage.getItem("schemeCodeModel") === "44" && (
                      <>
                        <option value="6">Central Agency</option>
                        <option value="7">State Agency</option>
                      </>
                    )}
                  </select>
                </div>

                {/* APPLY */}
                <div className="col-md-4 d-flex align-items-end">
                  <button
                    className="btn btn-success w-100"
                    onClick={() => {
                      if (!selectedState || !selectedRole) {
                        setErrorMessage("Please select State and Role");
                        return;
                      }
                      setErrorMessage(""); // Clear error message if validation passes
                      setShowTable(true);
                      fetchDataCentral(selectedState, selectedRole);
                    }}
                  >
                    Apply Filter
                  </button>
                </div>
                
                {/* ERROR MESSAGE */}
                {errorMessage && (
                  <div className="col-12 mt-2">
                    <div className="alert alert-warning mb-0" role="alert">
                      {errorMessage}
                    </div>
                  </div>
                )}

              </div>
            </div>
          )}

          {userType === "2" && (
  <div className="card p-3 mb-3">
    <div className="row g-3">

      {/* STATE */}
      <div className="col-md-4">
        <label className="form-label fw-semibold">State</label>
        <select className="form-select" value={selectedState} disabled>
          {stateOptions
            .filter(s => String(s.value) === String(stateFromSession))
            .map(s => (
              <option key={s.value} value={s.value}>
                {s.label}
              </option>
            ))}
        </select>
      </div>

      {/* DISTRICT */}
      <div className="col-md-4">
        <label className="form-label fw-semibold">District</label>
        <select
          className="form-select"
          value={selectedDistrict}
          onChange={(e) => {
            setSelectedDistrict(e.target.value);
            setErrorMessage(""); // Clear error when user changes selection
          }}
        >
          <option value="">Select District</option>
          {optionDistrict.map(d => (
            <option key={d.value} value={d.value}>
              {d.label}
            </option>
          ))}
        </select>
      </div>

      {/* APPLY */}
      <div className="col-md-4 d-flex align-items-end">
        <button
          className="btn btn-success w-100"
          onClick={() => {
            if (!selectedDistrict) {
              setErrorMessage("Please select District");
              return;
            }
            setErrorMessage(""); // Clear error message if validation passes
            setShowTable(true);
            fetchDataStateAdmin(selectedState, selectedDistrict);
          }}
        >
          Apply Filter
        </button>
      </div>
      
      {/* ERROR MESSAGE */}
      {errorMessage && (
        <div className="col-12 mt-2">
          <div className="alert alert-warning mb-0" role="alert">
            {errorMessage}
          </div>
        </div>
      )}

    </div>
  </div>
)}






          <div className="row justify-content-lg-center">
            <div className="col-lg-12 ">

              <div className="card">
                {showTable && userType === "1" && (
                  <MaterialReactTable
                    columns={columns}
                    data={usersData}
                    enableColumnOrdering
                    enablePagination={true}
                    state={{ isLoading: isFetching }}
                    muiTableBodyCellProps={{
                      sx: {
                        px: 1,
                        py: 0.5,
                        whiteSpace: 'nowrap',
                      },
                    }}
                    muiTableHeadCellProps={{
                      sx: {
                        px: 1,
                        py: 0.5,
                        whiteSpace: 'nowrap',
                      },
                    }}
                    muiTableProps={{
                      sx: {
                        tableLayout: 'fixed',
                        borderCollapse: 'collapse',
                      },
                    }}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1rem",
                          p: "0.5rem",
                          flexWrap: "wrap",
                        }}
                      >
                        <Button
                          color="primary"
                          onClick={() => handleExportData(table)}
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export in CSV
                        </Button>

                        <button className="btn btn-outline-primary ms-2" onClick={() => handleExportToExcel(table)}>
                          Download Excel
                        </button>
                      </Box>
                    )}
                  />
                )}
                {userType != "1" && (
                  <MaterialReactTable
                    columns={columns}
                    data={usersData}
                    enableColumnOrdering
                    enablePagination={true}
                    state={{ isLoading: isFetching }}
                    muiTableBodyCellProps={{
                      sx: {
                        px: 1,
                        py: 0.5,
                        whiteSpace: 'nowrap',
                      },
                    }}
                    muiTableHeadCellProps={{
                      sx: {
                        px: 1,
                        py: 0.5,
                        whiteSpace: 'nowrap',
                      },
                    }}
                    muiTableProps={{
                      sx: {
                        tableLayout: 'fixed',
                        borderCollapse: 'collapse',
                      },
                    }}
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1rem",
                          p: "0.5rem",
                          flexWrap: "wrap",
                        }}
                      >
                        <Button
                          color="primary"
                          onClick={() => handleExportData(table)}
                          startIcon={<FileDownloadIcon />}
                          variant="contained"
                        >
                          Export in CSV
                        </Button>

                        <button className="btn btn-outline-primary ms-2" onClick={() => handleExportToExcel(table)}>
                          Download Excel
                        </button>
                      </Box>
                    )}
                  />
                )}
              </div>

            </div>


          </div>
        </section>
      </main>


      <div className="modal fade" id="staticBackdrop_user" data-bs-backdrop="staticBackdrop_user" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteLabel"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
            </div>
            <div className="modal-body">
              <h6 id="deleteHeading">Are you sure you want to delete this record?</h6>


            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={deleteData}>Yes</button>
              <button type="button" className="btn border" data-bs-dismiss="modal">No</button>

            </div>
          </div>
        </div>
      </div>
      <div id="mpopupBox" className="modal">

        <div className="modal-content" >
          <div className="modal-header">
            <h2>View Details</h2>
            <button type="button" className="btn-close" onClick={removed}>X</button>
          </div>
          <div className="madal-body" id="modal-content" >



          </div>
          <div className="modal-footer">

          </div>
        </div>

      </div>

      <AdminFooterNew />
    </>
  )
}

export default UserList;